exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".document-management-app .title-view > :not(:last-child) {\n  margin-right: 0.5em;\n}\n.document-management-app .title-view a:hover {\n  color: #22C044;\n}\n", ""]);
